import React from "react";
import '../styles/PersonalPage.css';
import BackendConnector from "../middleware/BackendConnector";
import { Box, Button, Avatar, Typography } from "@mui/material";
import NavStruct from "../components/NavStruct";
import '../i18n';
import { useTranslation } from 'react-i18next';
import { useUser } from "../context/UserContext"


export default function PersonalPage() {
    const [t, i18n] = useTranslation();
    const userContext = useUser();
    return (
        <Box>
            <Box sx={{margin: '20px 0px 0px 50px'}}>
                <NavStruct/>
            </Box>
            <Box className="whiteBoard" sx={{bgcolor: 'background.paper'}}>
                <Box className="profileWrapper">
                    <Typography sx={{fontSize: 30}}>{t("Имя")}: {userContext.get_name()}</Typography>
                    <Typography sx={{fontSize: 25}}>{t("Логин")}: {userContext.get_login()}</Typography>
                    {
                        userContext.get_group() ?
                            <Typography sx={{ fontSize: 25 }}>{t("Группа")}: {userContext.get_group()}</Typography>
                            : null
                    }
                </Box>
                <Avatar className="avatar"/>
            </Box>
        </Box>
    );
}